import React from 'react'
import SummaryDetail from './SummaryDetail'
import CalendarDay from './CalendarDay'

class CalendarWeek extends React.Component {

  showSummary (data) {
    if (gon.summary){
      return false
    } else {
      if (this.props.summaryDataDate == data.date) {
        gon.summary = data
        return true
      } else {
        return false
      }
    }
  }

  resetSummary () {
    gon.summary = null
  }

  renderCalendarDay (dayData, index) {
    return (
      <CalendarDay
        key={index}
        data={dayData}
        displaySummary={this.props.displaySummary}
        showSummary={this.showSummary(dayData)}
        show_paid_leave={this.props.show_paid_leave}
        show_job_protected_leave={this.props.show_job_protected_leave}
        show_hidden_tasks={this.props.show_hidden_tasks}
      />
    )
  }

  renderSummaryDetail () {
    if (gon.summary) {
      return (
        <SummaryDetail
          summaryData={gon.summary}
          manageTimelineData={this.props.manageTimelineData}
          handleItemClick={this.props.handleItemClick}
          display_modal={this.props.display_modal}
          onHelpfulCheck={this.props.onHelpfulCheck}
          handleJustLookingClick={this.props.handleJustLookingClick}
          show_hidden_tasks={this.props.show_hidden_tasks}
          handleCustomTaskDelete={this.props.handleCustomTaskDelete}
          handleCustomTaskClick={this.props.handleCustomTaskClick}
          custom_task_modal={this.props.custom_task_modal}
          handleCustomTaskChange={this.props.handleCustomTaskChange}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
        />
      )
    } else {
      return null
    }
  }

  render () {
    return (
      <div className='calendar-week'>
        {this.props.data.map((dayData, index) => this.renderCalendarDay(dayData, index))}
        {this.renderSummaryDetail()}
        {this.resetSummary()}
      </div>
    )
  }
}

export default CalendarWeek;